'use client';

import dynamic from 'next/dynamic';

import { GenericLoader } from '@eliadmin/core/src/components/ui/generic-loader';

export { createOrderSchema } from '@eliadmin/core/src/pages/cart/cart-page-schema';
export type { CreateOrderFormValues } from '@eliadmin/core/src/pages/cart/cart-page-schema';

const CartPageContent = dynamic(
  () => import('@eliadmin/core/src/components/cart/cart-page-content'),
  {
    ssr: false,
    loading: () => <GenericLoader />,
  },
);

export default function CartPage() {
  return <CartPageContent />;
}
